import { Injectable } from '@angular/core';

@Injectable()
export class Globals {

  private static users = ['escuelapasa1', 'escuelapasa2', 'escuelacredito', 'oficina'];
  private static pass = 'apf2018';
  private static userFilters = [];
  private static adminVisibility = false;

  private static lang;

  static getUsers() {
    return this.users;
  }

  static getPass() {
    return this.pass;
  }

  static setUserFilters(filters: string[]) {
    this.userFilters = filters;
  }

  static getUserFilters() {
    return this.userFilters;
  }

  static setAdminVisibility(b: boolean) {
    this.adminVisibility = b;
  }

  static getAdminVisibility() {
    return this.adminVisibility;
  }

  static getLang(): string {
    return this.lang;
  }

  static setLang(value: string) {
    this.lang = value;
  }

}
